var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dashboard-component p-4",
      class: { "reservation-overview--loading": _vm.loading },
    },
    [
      _c("h3", { staticClass: "mb-3" }, [_vm._v("Boekingen - Jaaroverzicht")]),
      _vm._v(" "),
      _c("div", { staticClass: "row g-3 align-items-center mb-4" }, [
        _c("div", { staticClass: "col-auto" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedHouseId,
                  expression: "selectedHouseId",
                },
              ],
              staticClass: "form-select",
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selectedHouseId = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            [
              _c("option", { attrs: { value: "all" } }, [
                _vm._v("Alle huizen"),
              ]),
              _vm._v(" "),
              _vm._l(_vm.houses, function (house) {
                return _c(
                  "option",
                  { key: house.id, domProps: { value: house.id } },
                  [_vm._v("\n          " + _vm._s(house.title) + "\n        ")]
                )
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-auto" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedYear,
                  expression: "selectedYear",
                },
              ],
              staticClass: "form-select",
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selectedYear = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            _vm._l(_vm.years, function (year) {
              return _c("option", { key: year, domProps: { value: year } }, [
                _vm._v(_vm._s(year)),
              ])
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _vm.displayMode === "text"
          ? _c("div", { staticClass: "col-auto" }, [
              _c("label", { staticClass: "cancelled-filter" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.includeCancelled,
                      expression: "includeCancelled",
                    },
                  ],
                  staticClass: "cancelled-filter__input",
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.includeCancelled)
                      ? _vm._i(_vm.includeCancelled, null) > -1
                      : _vm.includeCancelled,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.includeCancelled,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.includeCancelled = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.includeCancelled = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.includeCancelled = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("span", [_vm._v("Geannuleerde tonen")]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-auto ms-auto" }, [
          _c(
            "div",
            {
              staticClass: "view-switch",
              attrs: { role: "group", "aria-label": "Weergavemodus" },
            },
            [
              _c(
                "button",
                {
                  staticClass: "view-switch__button",
                  class: { active: _vm.displayMode === "visual" },
                  attrs: {
                    type: "button",
                    "aria-label": "Visuele weergave",
                    title: "Visuele weergave",
                  },
                  on: {
                    click: function ($event) {
                      _vm.displayMode = "visual"
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    { attrs: { viewBox: "0 0 24 24", "aria-hidden": "true" } },
                    [
                      _c("rect", {
                        attrs: { x: "3", y: "3", width: "7", height: "7" },
                      }),
                      _c("rect", {
                        attrs: { x: "14", y: "3", width: "7", height: "7" },
                      }),
                      _c("rect", {
                        attrs: { x: "3", y: "14", width: "7", height: "7" },
                      }),
                      _c("rect", {
                        attrs: { x: "14", y: "14", width: "7", height: "7" },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "view-switch__button",
                  class: { active: _vm.displayMode === "text" },
                  attrs: {
                    type: "button",
                    "aria-label": "Tekstweergave",
                    title: "Tekstweergave",
                  },
                  on: {
                    click: function ($event) {
                      _vm.displayMode = "text"
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    { attrs: { viewBox: "0 0 24 24", "aria-hidden": "true" } },
                    [
                      _c("path", { attrs: { d: "M7 5h14M7 12h14M7 19h14" } }),
                      _c("circle", { attrs: { cx: "3", cy: "5", r: "1" } }),
                      _c("circle", { attrs: { cx: "3", cy: "12", r: "1" } }),
                      _c("circle", { attrs: { cx: "3", cy: "19", r: "1" } }),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "component-load" }, [
            _vm._v("Bezig met laden..."),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "reservation-total mb-4",
          attrs: { "aria-live": "polite" },
        },
        [
          _c("span", [_vm._v("Totaal " + _vm._s(_vm.selectedYear))]),
          _vm._v(" "),
          _c("strong", [
            _vm._v(
              _vm._s(_vm.selectedYearReservations.length) +
                " " +
                _vm._s(
                  _vm.reservationLabel(_vm.selectedYearReservations.length)
                )
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.selectedHouses.length && _vm.displayMode === "visual"
        ? _c(
            "div",
            {
              staticClass: "year-calendar",
              class: {
                "year-calendar--all-houses": _vm.selectedHouseId === "all",
              },
            },
            _vm._l(_vm.selectedHouses, function (house) {
              return _c(
                "div",
                { key: house.id, staticClass: "year-calendar__house mb-5" },
                [
                  _vm.selectedHouseId === "all"
                    ? _c("h4", [_vm._v(_vm._s(house.title))])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "year-calendar__months" },
                    _vm._l(_vm.monthNames, function (monthName, monthIndex) {
                      return _c(
                        "div",
                        { key: monthIndex, staticClass: "month-block mb-4" },
                        [
                          _c("h5", { staticClass: "month-block__heading" }, [
                            _c("span", [_vm._v(_vm._s(monthName))]),
                            _vm._v(" "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.reservationsForMonth(
                                    house,
                                    monthIndex + 1
                                  ).length
                                ) +
                                  " " +
                                  _vm._s(
                                    _vm.reservationLabel(
                                      _vm.reservationsForMonth(
                                        house,
                                        monthIndex + 1
                                      ).length
                                    )
                                  )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "year-calendar__header" },
                            _vm._l(7, function (d) {
                              return _c(
                                "div",
                                {
                                  key: d,
                                  staticClass: "year-calendar__header-day",
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.weekdayNames[d - 1]) +
                                      "\n        "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex flex-wrap gap-1" },
                            _vm._l(
                              _vm.getMonthGrid(monthIndex + 1),
                              function (day) {
                                return _c(
                                  "div",
                                  {
                                    key: day.key,
                                    staticClass:
                                      "d-flex align-items-center justify-content-center text-white",
                                    class: day.isPlaceholder
                                      ? "bg-light"
                                      : [
                                          _vm.dayColor(
                                            house,
                                            monthIndex + 1,
                                            day.value
                                          ),
                                          {
                                            "reservation-day":
                                              _vm.getReservations(
                                                house,
                                                monthIndex + 1,
                                                day.value
                                              ).length,
                                            "reservation-day--highlighted":
                                              !_vm.isChangeover(
                                                house,
                                                monthIndex + 1,
                                                day.value
                                              ) &&
                                              _vm.isHighlighted(
                                                house,
                                                monthIndex + 1,
                                                day.value
                                              ),
                                            "reservation-day--muted":
                                              _vm.hasHoveredReservation &&
                                              !_vm.isHighlighted(
                                                house,
                                                monthIndex + 1,
                                                day.value
                                              ),
                                          },
                                        ],
                                    staticStyle: {
                                      flex: "1 0 calc((100% - 6 * 0.25rem) / 7)",
                                      height: "34px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        !day.isPlaceholder &&
                                          !_vm.isChangeover(
                                            house,
                                            monthIndex + 1,
                                            day.value
                                          ) &&
                                          _vm.openReservation(
                                            house,
                                            monthIndex + 1,
                                            day.value
                                          )
                                      },
                                      mousemove: function ($event) {
                                        !day.isPlaceholder &&
                                          !_vm.isChangeover(
                                            house,
                                            monthIndex + 1,
                                            day.value
                                          ) &&
                                          _vm.hoverReservation(
                                            _vm.getReservation(
                                              house,
                                              monthIndex + 1,
                                              day.value
                                            ),
                                            house.id,
                                            _vm.getBooking(
                                              house,
                                              monthIndex + 1,
                                              day.value
                                            ).start,
                                            $event
                                          )
                                      },
                                      mouseleave: _vm.clearHoveredReservation,
                                    },
                                  },
                                  [
                                    !day.isPlaceholder &&
                                    _vm.isChangeover(
                                      house,
                                      monthIndex + 1,
                                      day.value
                                    )
                                      ? [
                                          _c(
                                            "svg",
                                            {
                                              staticClass:
                                                "reservation-day__split",
                                              attrs: {
                                                viewBox: "0 0 100 100",
                                                preserveAspectRatio: "none",
                                                "aria-hidden": "true",
                                              },
                                              on: {
                                                mouseleave:
                                                  _vm.clearHoveredReservation,
                                              },
                                            },
                                            [
                                              _c("polygon", {
                                                class: {
                                                  "reservation-day__split-half--faded":
                                                    _vm.hasHoveredReservation &&
                                                    !_vm.isReservationHighlighted(
                                                      _vm.getDepartureReservation(
                                                        house,
                                                        monthIndex + 1,
                                                        day.value
                                                      ),
                                                      house.id
                                                    ),
                                                },
                                                attrs: {
                                                  points:
                                                    "0,0 57,0 41,100 0,100",
                                                  fill: "#f5a623",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("polygon", {
                                                class: {
                                                  "reservation-day__split-half--faded":
                                                    _vm.hasHoveredReservation &&
                                                    !_vm.isReservationHighlighted(
                                                      _vm.getArrivalReservation(
                                                        house,
                                                        monthIndex + 1,
                                                        day.value
                                                      ),
                                                      house.id
                                                    ),
                                                },
                                                attrs: {
                                                  points:
                                                    "59,0 100,0 100,100 43,100",
                                                  fill: "#f5a623",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("polygon", {
                                                staticClass:
                                                  "reservation-day__split-hitarea",
                                                attrs: {
                                                  points:
                                                    "0,0 58,0 42,100 0,100",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    _vm.openReservationById(
                                                      _vm.getDepartureReservation(
                                                        house,
                                                        monthIndex + 1,
                                                        day.value
                                                      ).id
                                                    )
                                                  },
                                                  mousemove: function ($event) {
                                                    $event.stopPropagation()
                                                    _vm.hoverReservation(
                                                      _vm.getDepartureReservation(
                                                        house,
                                                        monthIndex + 1,
                                                        day.value
                                                      ),
                                                      house.id,
                                                      _vm.getBooking(
                                                        house,
                                                        monthIndex + 1,
                                                        day.value
                                                      ).start,
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("polygon", {
                                                staticClass:
                                                  "reservation-day__split-hitarea",
                                                attrs: {
                                                  points:
                                                    "58,0 100,0 100,100 42,100",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    _vm.openReservationById(
                                                      _vm.getArrivalReservation(
                                                        house,
                                                        monthIndex + 1,
                                                        day.value
                                                      ).id
                                                    )
                                                  },
                                                  mousemove: function ($event) {
                                                    $event.stopPropagation()
                                                    _vm.hoverReservation(
                                                      _vm.getArrivalReservation(
                                                        house,
                                                        monthIndex + 1,
                                                        day.value
                                                      ),
                                                      house.id,
                                                      _vm.getBooking(
                                                        house,
                                                        monthIndex + 1,
                                                        day.value
                                                      ).start,
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "reservation-day__number",
                                            },
                                            [_vm._v(_vm._s(day.value))]
                                          ),
                                        ]
                                      : !day.isPlaceholder &&
                                        _vm.isTransition(
                                          house,
                                          monthIndex + 1,
                                          day.value
                                        )
                                      ? [
                                          _c(
                                            "svg",
                                            {
                                              staticClass:
                                                "reservation-day__split",
                                              attrs: {
                                                viewBox: "0 0 100 100",
                                                preserveAspectRatio: "none",
                                                "aria-hidden": "true",
                                              },
                                            },
                                            [
                                              _c("polygon", {
                                                class: {
                                                  "reservation-day__split-half--faded":
                                                    _vm.hasHoveredReservation &&
                                                    _vm.isHighlighted(
                                                      house,
                                                      monthIndex + 1,
                                                      day.value
                                                    ) &&
                                                    !_vm.isDeparture(
                                                      house,
                                                      monthIndex + 1,
                                                      day.value
                                                    ),
                                                },
                                                attrs: {
                                                  points:
                                                    "0,0 57,0 41,100 0,100",
                                                  fill: _vm.isDeparture(
                                                    house,
                                                    monthIndex + 1,
                                                    day.value
                                                  )
                                                    ? "#f5a623"
                                                    : "#28a745",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("polygon", {
                                                class: {
                                                  "reservation-day__split-half--faded":
                                                    _vm.hasHoveredReservation &&
                                                    _vm.isHighlighted(
                                                      house,
                                                      monthIndex + 1,
                                                      day.value
                                                    ) &&
                                                    !_vm.isArrival(
                                                      house,
                                                      monthIndex + 1,
                                                      day.value
                                                    ),
                                                },
                                                attrs: {
                                                  points:
                                                    "59,0 100,0 100,100 43,100",
                                                  fill: _vm.isArrival(
                                                    house,
                                                    monthIndex + 1,
                                                    day.value
                                                  )
                                                    ? "#f5a623"
                                                    : "#28a745",
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "reservation-day__number",
                                            },
                                            [_vm._v(_vm._s(day.value))]
                                          ),
                                        ]
                                      : [
                                          _vm._v(
                                            _vm._s(
                                              day.isPlaceholder ? "" : day.value
                                            )
                                          ),
                                        ],
                                    _vm._v(" "),
                                    !day.isPlaceholder &&
                                    _vm.hoveredReservation &&
                                    _vm.hoveredHouseId === house.id &&
                                    _vm.hoveredDay ===
                                      _vm.getBooking(
                                        house,
                                        monthIndex + 1,
                                        day.value
                                      ).start
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "reservation-tooltip",
                                          },
                                          [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(
                                                  _vm.reservationTooltip(
                                                    _vm.hoveredReservation
                                                  )
                                                ) +
                                                "\n          "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              )
            }),
            0
          )
        : _vm.selectedHouses.length
        ? _c(
            "div",
            { staticClass: "year-calendar year-calendar--text" },
            _vm._l(_vm.monthNames, function (monthName, monthIndex) {
              return _c(
                "div",
                { key: monthIndex, staticClass: "month-block mb-4" },
                [
                  _c("h5", { staticClass: "reservation-list__heading" }, [
                    _c("span", [_vm._v(_vm._s(monthName))]),
                    _vm._v(" "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.reservationsForMonthAcrossHouses(monthIndex + 1)
                            .length
                        ) +
                          " " +
                          _vm._s(
                            _vm.reservationLabel(
                              _vm.reservationsForMonthAcrossHouses(
                                monthIndex + 1
                              ).length
                            )
                          )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.reservationsForMonthAcrossHouses(monthIndex + 1).length
                    ? _c(
                        "ul",
                        { staticClass: "reservation-list mb-0" },
                        _vm._l(
                          _vm.reservationsForMonthAcrossHouses(monthIndex + 1),
                          function (reservation, index) {
                            return _c("li", { key: reservation.id }, [
                              _c(
                                "button",
                                {
                                  staticClass: "reservation-list__item",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openReservationById(
                                        reservation.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(index + 1) +
                                      ". -> " +
                                      _vm._s(
                                        _vm.formatDate(reservation.arrivalDate)
                                      ) +
                                      " t/m " +
                                      _vm._s(
                                        _vm.formatDate(
                                          reservation.departureDate
                                        )
                                      ) +
                                      " - " +
                                      _vm._s(reservation.houseTitle) +
                                      " - " +
                                      _vm._s(reservation.fullName || "-") +
                                      " (" +
                                      _vm._s(reservation.agencyName || "-") +
                                      ") - " +
                                      _vm._s(
                                        _vm.formatDate(reservation.addedDate)
                                      ) +
                                      " "
                                  ),
                                  reservation.cancelled
                                    ? _c(
                                        "strong",
                                        {
                                          staticClass:
                                            "reservation-list__cancelled",
                                        },
                                        [_vm._v("Geannuleerd")]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ])
                          }
                        ),
                        0
                      )
                    : _c("p", { staticClass: "text-muted mb-0" }, [
                        _vm._v("Geen reserveringen."),
                      ]),
                ]
              )
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "cancelled-filter__toggle",
        attrs: { "aria-hidden": "true" },
      },
      [_c("span", { staticClass: "cancelled-filter__knob" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }